import { createTracker } from 'usage-tracker';

export const UniversalAuthTracker = createTracker({
  standalone: true,
});

export const UniversalAuthBeamTracker = UniversalAuthTracker.clone({});
